import * as runtime from '../runtime';
import { CustomerMeteringPoint, CustomerMeteringPointFromJSON } from '../models/CustomerMeteringPoint';
import { getCustomerVariables } from '../../features/context/CustomerContextHelper';
import { CustomerVariables } from '../../customerVariables/variable_interfaces';

export class CustomersApi extends runtime.BaseAPI {
    
    readonly customerVariables: CustomerVariables = getCustomerVariables();
    
    /**
      * Creates a request to link enterprise to customer
      */
    async createEnterpriseCustomer(customerMeteringPoints: CustomerMeteringPoint[]) {
        const response = await this.createEnterpriseCustomerRaw(customerMeteringPoints);
        return await response.value();
    }

    async createEnterpriseCustomerRaw(customerMeteringPoints: CustomerMeteringPoint[]): Promise<runtime.ApiResponse<CustomerMeteringPoint[]>> {
        if (customerMeteringPoints === null || customerMeteringPoints === undefined) {
            throw new runtime.RequiredError('customerMeteringPoints', 'Required parameter customerMeteringPoints was null or undefined when calling update.');
        }


        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/realms/${this.customerVariables.realmName}/wapice/customers/meteringPoints/`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: customerMeteringPoints
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CustomerMeteringPointFromJSON));
    }

    /**
  * Creates a request to verify enterprise customer
  */
    async verifyEnterpriseCustomer(enterpriseCustomers: any): Promise<CustomerMeteringPoint[]> {
        const response = await this.verifyEnterpriseCustomerRaw(enterpriseCustomers);
        return await response.value();
    }

    async verifyEnterpriseCustomerRaw(enterpriseCustomers: any): Promise<runtime.ApiResponse<CustomerMeteringPoint[]>> {
        if (enterpriseCustomers === null || enterpriseCustomers === undefined) {
            throw new runtime.RequiredError('enterpriseCustomers', 'Required parameter enterpriseCustomers was null or undefined when calling verify.');
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/realms/${this.customerVariables.realmName}/wapice/customers/meteringPoints/verify`,
            method: 'PUT',
            headers: headerParameters,
            body: enterpriseCustomers
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CustomerMeteringPointFromJSON));
    }
}